/** The ten national digits of a US number, or null. */
export const nationalDigits = (phone?: string | null): string | null => {
   const digits = (phone || '').replace(/\D/g, '')
   const national =
      digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits
   return national.length === 10 ? national : null
}

/** The three-digit US area code of a phone number, if it has one. */
export const areaCodeOf = (phone?: string | null): string | null => {
   const national = nationalDigits(phone)
   return national ? national.slice(0, 3) : null
}

/** "(719) 555-0100" from any US number; other input is returned as typed. */
export const prettyPhone = (phone?: string | null): string => {
   const national = nationalDigits(phone)
   if (!national) return phone || ''
   return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`
}

/** True for anything that looks like a dialable US number. */
export const isUsPhone = (phone?: string | null) =>
   Boolean(nationalDigits(phone))

/** "+17195550100" from any US number. */
export const e164 = (phone?: string | null): string => {
   const national = nationalDigits(phone)
   return national ? `+1${national}` : phone || ''
}

/** Readable "A, B and C". */
export const listSentence = (names: string[]) => {
   if (names.length <= 1) return names.join('')
   return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
}

export const plural = (n: number, one: string, many = `${one}s`) =>
   `${n} ${n === 1 ? one : many}`

/** What the backend said, or a fallback. Never Axios' "Request failed with status code 400". */
export const errorText = (error: unknown, fallback: string): string => {
   const e = error as {
      response?: { data?: { message?: unknown; errorMessages?: unknown } }
      message?: unknown
      errorMessages?: unknown
   }
   const data = e?.response?.data ?? e
   const list = Array.isArray(data?.errorMessages)
      ? (data.errorMessages as unknown[]).filter(
           (m): m is string => typeof m === 'string' && m.trim().length > 0
        )
      : []
   if (list.length) return list.join(' ')
   const message = typeof data?.message === 'string' ? data.message.trim() : ''
   if (message && !/^Request failed with status code/i.test(message))
      return message
   return fallback
}
